module.exports = __webpack_public_path__ + "img/primary_6x1_z16.25fe1602.svg";